import { render } from "./SuperAdminClients.vue?vue&type=template&id=59902097"
import script from "./SuperAdminClients.vue?vue&type=script&lang=js"
export * from "./SuperAdminClients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__